"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrialCreditBoostMinCreditsRemaining = exports.TrialCreditBoostMaxFreeCredits = exports.TrialCreditBoostIncrement = exports.TrialCreditBoostWatershed = exports.TrialCreditBoostPeriod = exports.TrialReactivationMinimumExpiredDays = exports.TrialReactivationWatershed = exports.TrialPeriodDays = void 0;
/**
 * Number of days the individual trial lasts for
 */
exports.TrialPeriodDays = 14;
/**
 * Date for a point in time where we want to start allowing trial reactivations
 *
 * The full logic is:
 *  - If the user's most recent trial ended before this timestamp, AND
 *  - The user's most recent trial is currently expired
 * then they can reactivate and get a new trial of TrialPeriodDays length
 *
 * Trials that ended after this date are not eligible for reactivation.
 */
exports.TrialReactivationWatershed = new Date("2026-01-15T00:00:00Z");
/**
 * Number of days a trial must have been expired before it can be reactivated
 *
 * This prevents "auto-renewal" behavior where trials that have recently expired
 * can be immediately reactivated. Users must wait this many days after their
 * trial expires before they become eligible for reactivation.
 */
exports.TrialReactivationMinimumExpiredDays = 30;
/**
 * Credit boost promotion configuration for Cyber Monday 2025
 *
 * Users in an active or expiring trial who have low free credits remaining can receive a one-time
 * credit boost during the November 2025 billing period.
 */
/**
 * The credit period during which the credit boost promotion is active (November 2025)
 */
exports.TrialCreditBoostPeriod = "p_202511";
/**
 * Watershed date for the credit boost promotion - must be before this date to receive the boost
 * Set to midnight UTC on the Sunday before Cyber Monday 2025
 */
exports.TrialCreditBoostWatershed = new Date("2025-11-30T00:00:00Z");
/**
 * Amount of free credits to add when the credit boost is applied
 */
exports.TrialCreditBoostIncrement = 500;
/**
 * Maximum free credits a user can have after the boost is applied (acts as a cap to ensure idempotency)
 */
exports.TrialCreditBoostMaxFreeCredits = 1000;
/**
 * Minimum free credits remaining threshold to trigger the credit boost check
 * Users with fewer than this many credits remaining are eligible for the boost
 */
exports.TrialCreditBoostMinCreditsRemaining = 100;
//# sourceMappingURL=trial.js.map